import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalFullscreen } from '@cian/ui-kit';

import { ReviewPopupMobile } from '../../components/ReviewPopupMobile';
import { getQuestionById } from '../../selectors/questions';
import { AnswerListContainer } from '../QuestionAnswerList';
import { QuestionItemContainer } from '../QuestionItem/QuestionItemContainer';
import { loadQuestionAnswers } from '../../actions/questionAnswers';

export interface IReviewPopupContainerProps {
  questionId: string;
  onClose(): void;
}

export const QuestionPopupContainer: React.FC<IReviewPopupContainerProps> = props => {
  const { questionId, onClose } = props;

  const dispatch = useDispatch();
  const { answersCount } = useSelector(getQuestionById(questionId));

  React.useEffect(() => {
    dispatch(
      loadQuestionAnswers({
        questionId,
        page: 0,
      }),
    );
  }, [questionId, dispatch]);

  return (
    <ModalFullscreen open onClose={onClose} theme="white">
      <ReviewPopupMobile
        title="Отзыв"
        close={onClose}
        review={<QuestionItemContainer id={questionId} inPopup />}
        answersCount={answersCount}
        answers={<AnswerListContainer questionId={questionId} inPopup />}
      />
    </ModalFullscreen>
  );
};
